import { FieldNames } from 'Constants/FieldNames'

export const translateOptions = {
	[FieldNames.ORG_NAME]: 'Общество с ограниченной ответственностью',
	[FieldNames.ORG_SHORT_NAME]: 'ООО',
	[FieldNames.INTERNATIONAL_ORG_NAME]: 'Limited liability company',
	[FieldNames.INTERNATIONAL_ORG_SHORT_NAME]: 'LLC',
}

export const isLatinFields = [
	FieldNames.INTERNATIONAL_ORG_NAME,
	FieldNames.INTERNATIONAL_ORG_SHORT_NAME,
]
